module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "mailgun-logo.fa77f3e9.png";